import { useSelector } from 'react-redux'

/**
 * Custom hook to get patient data from a notification with fallback
 * @param {Object} grinNotification - The notification object
 * @returns {Object} Patient data with name, profilePicture, etc.
 */
export const usePatientFromNotification = grinNotification => {
  // First, try to use the relatedPatientSM if available
  const relatedPatient = grinNotification?.relatedPatientSM

  // Fallback: search for patient in chatReducer.rooms using relatedPatientId
  const fallbackPatient = useSelector(state =>
    grinNotification?.relatedPatientId
      ? state.chatReducer.rooms.find(patientSM => patientSM.id === grinNotification.relatedPatientId)
      : null
  )

  return relatedPatient || fallbackPatient || null
}
